import { NamedDefinitionPage } from './NamedDefinitionPage';

export function PaymentTypesPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/paymenttypes"
      listRoute="/payment-types"
      title="Payment Type Yonetimi"
      subtitle="Odeme girisinde kullanilacak odeme tiplerini yonetin."
      codeLabel="Kod"
      descriptionLabel="Odeme Tipi"
      newLabel="Yeni Odeme Tipi"
    />
  );
}
